import { Button, Card, Col, Input, Row } from 'antd'
import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { setOrderNumberAction } from '../../../../../../store/generate-table/reducer'
import { selectDisabledOrderForm, selectLinkToTable, selectOrderNumber } from '../../../../../../store/generate-table/selectors'
import { TableGenerationModal } from '../TableGenerationModal/TableGenerationModal'
import { TableImportModal } from '../TableImportModal/TableImportModal'

type TableGenerationProps = {
  isButtonDisabled: boolean;
  isLoading: boolean;
  generateSpreadsheet: (isWithSavingData: boolean) => void;
  importTable: (parentDealId: number) => void;
}

function useQuery() {
  const { search } = useLocation()
  return React.useMemo(() => new URLSearchParams(search), [search])
}

export function TableGeneration({
  isButtonDisabled,
  isLoading,
  generateSpreadsheet,
  importTable,
}: TableGenerationProps) {
  const dispatch = useDispatch()
  const query = useQuery()
  const urlNumber = query.get('number') ? query.get('number') : ''
  const orderNumber = useSelector(selectOrderNumber)
  const isOrderDisabled = useSelector(selectDisabledOrderForm)
  const linkToTable = useSelector(selectLinkToTable)
  const [isTableGenerationModalVisible, setTableGenerationModalVisibility] = useState<boolean>(false)
  const [isTableImportModalVisible, setTableImportModalVisibility] = useState<boolean>(false)

  const setOrderNumber = useCallback((value: string) => {
    const newOrderNumber: string =
      Array.from(value.trim())
        .filter(item => Number.isInteger(parseInt(item, 10)))
        .join('')

    dispatch(setOrderNumberAction(newOrderNumber))
  }, [dispatch])

  const confirmSpreadsheetGeneration = useCallback(() => {
    setTableGenerationModalVisibility(true)
  }, [])

  const confirmImportTable = useCallback(() => {
    setTableImportModalVisibility(true)
  }, [])

  const onGenerateSpreadsheetClick = useCallback(() => {
    if (linkToTable) {
      confirmSpreadsheetGeneration()
      // return
    }

    // generateSpreadsheet(false)
  }, [linkToTable, confirmSpreadsheetGeneration, generateSpreadsheet])

  return (
    <Card>
      <Row>
        <Col
          span={10}
          className='pr-2'
        >
          <Input
            addonBefore={<span>Номер сделки</span>}
            placeholder='Введите номер'
            disabled={isOrderDisabled}
            value={orderNumber}
            onChange={e => setOrderNumber(e.target.value)}
          />
        </Col>
        <Col
          span={8}
          className='pl-2'
        >
          <Button
            type='primary'
            disabled={isButtonDisabled || !linkToTable}
            block
            onClick={onGenerateSpreadsheetClick}
          >
            Перегенерировать таблицу
          </Button>
        </Col>
        <Col
          span={6}
          className='pl-2'
        >
          <Button
            block
            disabled={isButtonDisabled}
          >
            <a
              href={linkToTable}
              target='_blank'
            >
              Открыть таблицу
            </a>
          </Button>
        </Col>
      </Row>
      <Row className='mt-[20px]'>
        <Col
          span={10}
          className='pr-2'
        />
        <Col
          span={8}
          className='pl-2'
        >
          <Button
            type='primary'
            disabled={isButtonDisabled || !urlNumber}
            block
            onClick={confirmImportTable}
          >
            Импортировать таблицу
          </Button>
        </Col>
      </Row>
      <TableGenerationModal
        isVisible={isTableGenerationModalVisible}
        onClose={() => setTableGenerationModalVisibility(false)}
        generateSpreadsheet={generateSpreadsheet}
      />
      <TableImportModal
        isVisible={isTableImportModalVisible}
        onClose={() => setTableImportModalVisibility(false)}
        importTable={importTable}
      />
    </Card>
  )
}
